import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {backgroundsData} from 'data/backgrounds-data';
import Login from './login';
import Background from 'components/ui/background/background';
import './login.scss';

class LoginController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoggedIn: false,
			playerLoginType: null,
			gameData: null,
			userId: null,
			isFacilitator: false,
			email: null,
			backgroundId: 'outside',
			backgroundModifier: 'top',
			backgroundStatus: 'show',
			shakeScreen: false,
			bgLanguageId: this.props.languageId
		};
		this.timeout = null;
		this.unsubscribeOnAuthStateChanged = null;
	}

	/**
	 * Switch between facilitator / player login box
	 * @param {string} activeLoginBox 
	 */
	setActiveLoginBox = (activeLoginBox) => {
		this.setState({activeLoginBox});
	};

	/**
	 * Switch background
	 * @param {string} languageId 
	 * @param {string} backgroundId 
	 * @param {string} backgroundModifier 
	 */
	setBackground = (languageId, backgroundId, backgroundModifier = null) => {
		if (
			backgroundId !== this.state.backgroundId || 
			backgroundModifier !== this.state.backgroundModifier
		) {
			/* Get background data */
			const backgroundData = backgroundsData.find((b) => {return b.id === backgroundId;});
			if (backgroundData) {
				/* Check position id */
				let newBackgroundModifier = backgroundModifier;
				if (
					backgroundData.modifiers.length > 0 &&
					(
						!backgroundModifier || 
						!backgroundData.modifiers.some((p) => {return p.id === newBackgroundModifier;})
					)
				) {
					/* Position required, but no position id or invalid position id provided */
					newBackgroundModifier = backgroundData.modifiers[0].id;
				}

				if (
					backgroundId !== this.state.backgroundId ||
					newBackgroundModifier !== this.state.backgroundModifier
				) {
					let backgroundStatus = (backgroundId === this.state.backgroundId ? 'pan' : 'fade');
					if (
						(this.state.backgroundModifier && this.state.backgroundModifier.includes('zoom')) || 
						(newBackgroundModifier && newBackgroundModifier.includes('zoom'))
					) {
						backgroundStatus = 'zoom';
					}
					this.setState({
						bgLanguageId: languageId,
						backgroundId: backgroundId,
						backgroundModifier: newBackgroundModifier,
						backgroundStatus: backgroundStatus
					});
				}
			}
		}
	};

	/**
	 * Update background status (show, pan, fade, zoom)
	 * @param {string} status 
	 */
	updateBackgroundStatus = (status) => {
		this.setState({backgroundStatus: status});
	};


	/**
 	* Render component
 	*/
	render() {
		
		/* Get scenario id */
		const gameData = this.state.gameData;
		const scenarioId = (gameData && gameData.scenarioId ? gameData.scenarioId : 'scenario-1');

		return (
			<div className={'LoginController' + (this.state.shakeScreen ? ' shake' : '')}>
				<Background
					scenarioId={scenarioId} 
					bgLanguageId={this.props.languageId}
					backgroundId={'outside'}
					backgroundModifier={this.state.backgroundModifier}
					backgroundStatus={this.state.backgroundStatus}
					updateBackgroundStatus={this.updateBackgroundStatus}
					deviceInfo={this.props.deviceInfo}
				/>
				<Login 
					languageId={this.props.languageId}
					playerLoginType={this.state.playerLoginType}
					deviceInfo={this.props.deviceInfo}
					gameData={this.state.gameData}
					activeLoginBox={this.state.activeLoginBox}
					setActiveLoginBox={this.setActiveLoginBox}
					startWithoutLogin={this.startWithoutLogin}
				/>
			</div>
		);
	}
}

LoginController.propTypes = {
	deviceInfo: PropTypes.object.isRequired,
	languageId: PropTypes.string.isRequired,
};

export default LoginController;